import { createSelector } from 'reselect';
import { getSlice } from './deviations';

export const getShippingProfilesState = createSelector(getSlice, slice => slice.shippingProfiles);

export const getShippingProfiles = createSelector(
  getShippingProfilesState,
  state => state?.profiles ?? []
);

export const getShippingDestinations = createSelector(
  getShippingProfilesState,
  state => state?.destinations ?? []
);

export const getShippingProfilesStatus = createSelector(
  getShippingProfilesState,
  state => state?.status ?? 'uninitialized'
);

export const getShippingDestinationsStatus = createSelector(
  getShippingProfilesState,
  state => state?.destinationsStatus ?? 'uninitialized'
);

export const getShippingProfilesSavingStatus = createSelector(
  getShippingProfilesState,
  state => state?.savingStatus ?? 'idle'
);
